import { Dispatch } from 'redux';
import { PaginatedResponse } from '@synergy/api';

import { Api } from '../../../../api';
import { AppState } from '../../../../store/models/app-state';
import { DemandOverview } from '../models/demand-overview';

export const CHANGE_TAB = 'CHANGE_TAB';
export const RECEIVE_DEMAND_OVERVIEW = 'RECEIVE_DEMAND_OVERVIEW';
export const REQUEST_DEMAND_OVERVIEW = 'REQUEST_DEMAND_OVERVIEW';
export const RESET_DEMANDS_OVERVIEW = 'RESET_DEMANDS_OVERVIEW';

const receiveDemandOverview = (paginatedDemandOverview: PaginatedResponse<DemandOverview>) => {
    return {
        type: RECEIVE_DEMAND_OVERVIEW,
        paginatedDemandOverview,
    };
};

export const resetDemandOverview = () => {
    return {
        type: RESET_DEMANDS_OVERVIEW,
    };
};

export const changeTab = (tabNumber: number) => {
    return {
        type: CHANGE_TAB,
        tabNumber,
    };
};

export const fetchDemandOverview = (searchParams: URLSearchParams) => {
    return async (dispatch: Dispatch, getState: () => AppState, { api }: { api: Api }) => {
        const customerAccountId = getState().account?.id;

        if (!customerAccountId) {
            return;
        }

        dispatch({ type: REQUEST_DEMAND_OVERVIEW });

        const response = await api.demand.DemandOverview.cget(customerAccountId, searchParams);

        if (response.success) {
            dispatch(receiveDemandOverview(response.result));
        }
    };
};
